import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared/security/auth.guard';
import { StartTransferEmployerComponent } from './start-transfer-employer/start-transfer-employer.component';
import { SearchEmployeesComponent } from './search-employees/search-employees.component';
import { SelectEmployeesComponent } from './select-employees/select-employees.component';
import { TransferEmployerCloseOfficeService } from './transfer-employer-close-office.service';
import { FormsModule } from '@angular/forms';
import { PipeModule } from '../../shared/pipes/pipe.module';
import { PTLSharedModule } from '../../shared/shared.module';
import { ListCancelActionsComponent } from './list-cancel-actions/list-cancel-actions.component';
import { SeverTransferReviewComponent } from './sever-transfer-review/sever-transfer-review.component';
import { NgxPrintModule } from 'ngx-print';
import { ConfirmCloseOfficeComponent } from './confirm-close-office/confirm-close-office.component';
import { SeverTransferReceiptComponent } from './sever-transfer-receipt/sever-transfer-receipt.component';

const routes: Routes = [
  { path: 'transferEmployer', component: StartTransferEmployerComponent, canActivate: [AuthGuard]},
  { path: 'searchEmployees', component: SearchEmployeesComponent, canActivate: [AuthGuard]},
  { path: 'selectEmployees', component: SelectEmployeesComponent, canActivate: [AuthGuard]},
  { path: 'listCancelActions', component: ListCancelActionsComponent, canActivate: [AuthGuard]},
  { path: 'severTransferReview', component: SeverTransferReviewComponent, canActivate: [AuthGuard]},
  { path: 'severTransferReceipt', component: SeverTransferReceiptComponent, canActivate: [AuthGuard]},
  { path: 'confirmCloseOffice', component: ConfirmCloseOfficeComponent, canActivate: [AuthGuard]}
  
];
@NgModule({
  imports: [
    CommonModule,RouterModule.forChild(routes), FormsModule, PipeModule, PTLSharedModule, NgxPrintModule
  ],
  
  declarations: [StartTransferEmployerComponent,SearchEmployeesComponent,SelectEmployeesComponent, ListCancelActionsComponent, SeverTransferReviewComponent, SeverTransferReceiptComponent, ConfirmCloseOfficeComponent],
  providers :[TransferEmployerCloseOfficeService]
})
export class TransferEmployerCloseOfficeModule { }



// WEBPACK FOOTER //
// ./src/app/broker/transfer-employer-close-office/transfer-employer-close-office.module.ts